/* ============================================================
   BLACKLIST CART EXTRAS - quick-view + price-breakdown modals.
   Additive only. Adds via /cart/add.js; never touches the checkout
   button, cart form, or Magic Checkout. All DOM access is guarded.
   ============================================================ */
(function () {
  'use strict';
  var money = function (cents) {
    try { return '₹' + (cents / 100).toLocaleString('en-IN'); } catch (e) { return '₹' + (cents / 100); }
  };

  function modal(id) { return document.getElementById(id); }
  function openModal(el) { if (el) { el.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
  function closeModal(el) { if (el) { el.hidden = true; document.documentElement.style.overflow = ''; } }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (b) {
          b.textContent = c.item_count; b.setAttribute('data-cart-count', c.item_count);
        });
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: c }));
        } catch (e) {}
        return c;
      });
  }

  /* ---------------- Quick view ---------------- */
  function buildQuickView(p) {
    var qv = modal('bl-quickview');
    if (!qv) return;
    var slides = (p.images || []).map(function (src) {
      return '<div class="bl-cc__slide"><img src="' + src + '" alt="' + (p.title || '') + '" loading="lazy"></div>';
    }).join('');
    var variants = p.variants || [];
    var chips = variants.map(function (v) {
      return '<button type="button" class="bl-qv__chip' + (v.available ? '' : ' is-soldout') + '" ' +
        (v.available ? '' : 'disabled ') + 'data-variant-id="' + v.id + '">' +
        (v.title === 'Default Title' ? 'Add' : v.title) + '</button>';
    }).join('');
    qv.querySelector('[data-qv-body]').innerHTML =
      '<div class="bl-media bl-qv__media"><div class="bl-cc__track">' + slides + '</div></div>' +
      '<div class="bl-qv__info">' +
        '<p class="bl-qv__title">' + (p.title || '') + '</p>' +
        '<p class="bl-qv__price">' + money(p.price) + '</p>' +
        '<div class="bl-qv__chips">' + chips + '</div>' +
        '<button type="button" class="bl-qv__add" data-qv-add disabled>Select a size</button>' +
      '</div>';
    var selected = null;
    var addBtn = qv.querySelector('[data-qv-add]');
    // preselect if only one variant
    if (variants.length === 1 && variants[0].available) {
      selected = variants[0].id; addBtn.disabled = false; addBtn.textContent = 'Add to bag';
      var only = qv.querySelector('.bl-qv__chip'); if (only) only.classList.add('is-active');
    }
    qv.querySelectorAll('[data-variant-id]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        qv.querySelectorAll('.bl-qv__chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        selected = chip.getAttribute('data-variant-id');
        addBtn.disabled = false; addBtn.textContent = 'Add to bag';
      });
    });
    addBtn.addEventListener('click', function () {
      if (!selected) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return refreshCart();
      }).then(function () {
        addBtn.textContent = 'Added ✓';
        setTimeout(function () { closeModal(qv); }, 700);
      }).catch(function () { addBtn.disabled = false; addBtn.textContent = 'Try again'; });
    });
    openModal(qv);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quickview-handle]');
    if (t) {
      e.preventDefault();
      var handle = t.getAttribute('data-quickview-handle');
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(buildQuickView).catch(function () {});
      return;
    }
    /* ---------------- Price breakdown ---------------- */
    var b = e.target.closest('[data-breakdown-open]');
    if (b) {
      e.preventDefault();
      var bm = modal('bl-breakdown');
      if (!bm) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var rows = (c.items || []).map(function (i) {
            return '<div class="bl-bd__row"><span>' + i.quantity + '× ' + i.product_title + '</span><span>' + money(i.final_line_price) + '</span></div>';
          }).join('');
          var discount = c.total_discount ? '<div class="bl-bd__row"><span>Discount</span><span>-' + money(c.total_discount) + '</span></div>' : '';
          bm.querySelector('[data-bd-body]').innerHTML =
            rows +
            '<hr class="bl-bd__hr">' +
            '<div class="bl-bd__row"><span>Subtotal</span><span>' + money(c.items_subtotal_price) + '</span></div>' +
            discount +
            '<div class="bl-bd__row bl-bd__muted"><span>Taxes</span><span>Included</span></div>' +
            '<div class="bl-bd__row bl-bd__muted"><span>Shipping</span><span>Calculated at checkout</span></div>' +
            '<div class="bl-bd__row bl-bd__total"><span>Total</span><span>' + money(c.total_price) + '</span></div>';
          openModal(bm);
        }).catch(function () {});
      return;
    }
    /* ---------------- Offer code: Copy ---------------- */
    var cp = e.target.closest('[data-copy-code]');
    if (cp) {
      e.preventDefault();
      var code = cp.getAttribute('data-copy-code') || '';
      var done = function () {
        var prev = cp.textContent; cp.textContent = 'Copied';
        setTimeout(function () { cp.textContent = prev || 'Copy'; }, 1400);
      };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea'); ta.value = code;
          ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta);
          ta.select(); try { document.execCommand('copy'); } catch (err) {} document.body.removeChild(ta); done();
        }
      } catch (err) { done(); }
      return;
    }
    /* close buttons / backdrops */
    if (e.target.closest('[data-modal-close]')) {
      var m = e.target.closest('.bl-modal'); if (m) closeModal(m);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.bl-modal:not([hidden])').forEach(closeModal);
  });
})();
